import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@/components/auth/AuthProvider';
import { useEffect } from 'react';
import { Database, SignIn } from '@phosphor-icons/react';

function LoginPage() {
  const { user, loading, error, loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && !loading) {
      navigate({ to: '/dashboard' });
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8f6f6]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F172A]">
      <div className="bg-white rounded-xl shadow-2xl p-10 w-full max-w-md text-center">
        <div className="bg-primary p-3 rounded-xl w-fit mx-auto mb-6">
          <Database size={28} weight="regular" className="text-white" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">IntelliTryx Admin</h1>
        <p className="text-slate-500 text-sm mb-8">
          Sign in with your Kombatix Google account to access the admin portal.
        </p>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl p-4 mb-6">
            {error}
          </div>
        )}

        <button
          onClick={loginWithGoogle}
          className="w-full bg-primary hover:bg-primary/90 text-white font-bold py-3 px-6 rounded-xl transition-all shadow-lg shadow-primary/20 flex items-center justify-center gap-3"
        >
          <SignIn size={18} weight="regular" />
          Sign in with Google
        </button>

        <p className="text-[10px] text-slate-400 mt-6 uppercase tracking-widest font-bold">
          Restricted to @kombatix.io accounts
        </p>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/login')({
  component: LoginPage,
});
